import { render, staticRenderFns } from "./Properties.vue?vue&type=template&id=aee59d78&scoped=true&"
import script from "./Properties.vue?vue&type=script&lang=js&"
export * from "./Properties.vue?vue&type=script&lang=js&"
import style0 from "./Properties.vue?vue&type=style&index=0&id=aee59d78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aee59d78",
  null
  
)

export default component.exports